"use client";

import { sendGAEvent } from "@next/third-parties/google";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

function hasDataLayer(): boolean {
  if (typeof window === "undefined") return false;
  return Array.isArray(
    (window as unknown as { dataLayer?: unknown }).dataLayer,
  );
}

export function GAPageViews({ gaId }: { gaId: string }) {
  const pathname = usePathname();

  useEffect(() => {
    if (!gaId) return;
    if (!hasDataLayer()) return;

    const query = window.location.search;
    const page_path = query ? `${pathname}${query}` : pathname;

    // SPA navigation needs explicit page_view updates.
    sendGAEvent("config", gaId, { page_path });
  }, [gaId, pathname]);

  return null;
}
